import styled from '@emotion/styled';
import { Text } from '@/components/atoms/Text';

export const DetailContainer = styled.div`
    display: flex;
    flex-direction: column;
    ${({ theme }) => theme.breakpoints.desktop} {
        display: grid;
        grid-template-columns: 1fr 2fr;
        margin-top: ${({ theme }) => theme.spacing[4]};
    }
    gap: ${({ theme }) => theme.spacing[4]};
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const ChipsContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[2]};
    flex-wrap: wrap;
    justify-content: right;
    ${({ theme }) => theme.breakpoints.mobile} {
        justify-content: space-between;
        max-width: 100%;
    }
`;

export const Chips = styled.div`
    display: flex;
    background: ${({ theme }) => theme.color.grey100};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    justify-content: center;
    align-items: center;
    padding: ${({ theme }) => theme.spacing[2]};
    gap: ${({ theme }) => theme.spacing[1]};
    color: ${({ theme }) => theme.color.black200};
`;

export const ChipsValue = styled.span`
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.bold};
`;

export const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[1]};
`;

export const StyledLabel = styled(Text)`
    ${({ theme }) => theme.font.caption.bold};
    line-height: 20px;
`;

export const StyledValue = styled.div`
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.size.medium};
    font-weight: ${({ theme }) => theme.font.weight.medium};
    color: ${({ theme }) => theme.color.black};
`;

export const StyledLinkValue = styled(StyledValue)`
    text-decoration: underline;
`;
